export const hasNavigationLinks = (navigationGroup) => {
    return navigationGroup.type === 'WithNavigationLinks';
};
